import React from "react";
import Layout from "../../components/Layout";
import "./DivingMedicine.css";
import image from "../../images/2.png";
import InfoCard from "src/components/InfoCard";

const divingmedicine: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"Diving Medicine"} image={image}>
        <div className="diving-details">
          <p>
            It is the diagnosis, treatment and prevention of conditions caused
            by humans entering the undersea environmen
          </p>
          <p>
            <strong></strong>
            <br></br>• DOTMEDICA supports the recreational and commercial diving
            community.<br></br>
            <br></br>• Our diving doctors can offer advice, assessment, or
            treatment as necessary.<br></br>
            <br></br>• Our primary aim is to provide advice to anyone during a
            diving emergency or who thinks that they may have decompression
            illness (DCI) following a dive.<br></br>
            <br></br>• We also answer many inquiries about diver health and
            carry out diver medicals 'IMCA Diving Fitness Certification' by IMCA
            approved examiners.<br></br>
            <br></br>• Emergency Advice & Treatment: The Diver Emergency
            Helpline is manned 24/7 every day of the year by our Diving
            Physicians for diving emergency advice and support.<br></br>
          </p>
          <p>
            <strong></strong>
            <br></br>
            IMCA (The International Marine Contractors Association) is the
            international trade association representing companies and
            organizations engaged in delivering offshore, marine, and underwater
            solutions
          </p>
          <p>
            <strong></strong>
            <br></br>
            It publishes a list of doctors that are recognized by the diving
            contractors and DOTMEDICA Doctors are approved to give medical
            fitness certificates for Professional Divers.
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default divingmedicine;
